'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.build = build;
exports.rebuild = rebuild;
function buildRows() {
    var slideElement = this.elements.slider;
    if (!slideElement.children) {
        console.error('no slides found');
        return;
    }

    var viewport = slideElement.querySelector('.' + this.config.classes.viewport);

    if (!viewport) {
        throw new Error('viewport is missing');
    }

    var track = slideElement.querySelector('.' + this.config.classes.track);

    if (!track) {
        throw new Error('viewport is track');
    }

    var slides = [];

    for (var i = 0; i < track.children.length; i++) {
        if (!track.children[i].classList.contains(this.config.classes.slide)) {
            track.children[i].classList.add(this.config.classes.slide);
        }
        slides.push(track.children[i]);
    }

    this.slideCount = slides.length;

    this.elements = _extends({}, this.elements, {
        slides: slides,
        viewport: viewport,
        track: track
    });
}

function cleanupInfiniteRows() {
    var clonedSlides = this.elements.track.querySelectorAll('.' + this.config.classes.slideClone);
    for (var i = 0; i < clonedSlides.length; i++) {
        clonedSlides[i].remove();
    }

    var slides = this.elements.track.querySelectorAll('.' + this.config.classes.slide);

    this.elements = _extends({}, this.elements, {
        slides: slides
    });
}

function buildInifiniteRows() {
    cleanupInfiniteRows.call(this);
    if (!this.config.options.infinite || this.config.options.fade || this.slideCount <= 1) {
        this.config.options.infinite = false;
        return;
    }

    var cloneSlideExists = this.elements.track.querySelector(this.config.classes.slideClone);
    if (cloneSlideExists) {
        return;
    }

    if (this.elements.slides.length < this.config.options.slidesToShow) {
        return;
    }

    for (var i = 0; i < this.config.options.slidesToShow; i++) {
        var firstSlideClone = this.elements.slides[i].cloneNode(true);
        firstSlideClone.classList.add(this.config.classes.slideClone);
        this.elements.track.appendChild(firstSlideClone);
    }

    var start = this.elements.slides.length - 1;
    var end = this.elements.slides.length - this.config.options.slidesToShow;
    var before = this.elements.slides[0];

    for (var _i = start; _i >= end; _i--) {
        var lastSlideClone = this.elements.slides[_i].cloneNode(true);
        lastSlideClone.classList.add(this.config.classes.slideClone);
        this.elements.track.insertBefore(lastSlideClone, before);
        before = lastSlideClone;
    }

    var slides = this.elements.track.querySelectorAll('.' + this.config.classes.slide);
    slides = Array.prototype.slice.call(slides);

    this.elements = _extends({}, this.elements, {
        slides: slides
    });
}

function cleanupArrows() {
    this.elements.nextArrow && this.elements.nextArrow.remove();
    this.elements.prevArrow && this.elements.prevArrow.remove();

    this.elements = _extends({}, this.elements, {
        nextArrow: null,
        prevArrow: null
    });
}

function buildArrows() {
    cleanupArrows.call(this);
    if (!this.config.options.arrows || this.slideCount <= 1) {
        return;
    }

    if (this.elements.nextArrow && this.elements.nextArrow.innerHTML === this.config.arrows.next) {
        return;
    }

    var slideElement = this.elements.slider;

    var prevArrow = document.createElement('div');
    prevArrow.innerHTML = this.config.arrows.prev;
    prevArrow = prevArrow.firstElementChild;

    var nextArrow = document.createElement('div');
    nextArrow.innerHTML = this.config.arrows.next;
    nextArrow = nextArrow.firstElementChild;

    // slideElement.insertBefore(prevArrow, this.elements.viewport)
    // slideElement.appendChild(nextArrow)

    var dotNav = this.elements.dotNav;
    dotNav.prepend(prevArrow);
    dotNav.appendChild(nextArrow);

    this.elements = _extends({}, this.elements, {
        nextArrow: nextArrow,
        prevArrow: prevArrow
    });
}

function cleanupDots() {
    this.elements.dotNav && this.elements.dotNav.remove();

    this.elements = _extends({}, this.elements, {
        dotNav: null,
        dots: []
    });
}

function buildDots() {
    cleanupDots.call(this);

    if (!this.config.options.dots || this.slideCount <= 1) {
        this.config.options.dots = false;
        return;
    }

    var slideElement = this.elements.slider;

    var dotNav = document.createElement('div');
    dotNav.classList.add(this.config.classes.dotList);

    for (var i = 0; i < this.slideCount; i++) {
        var dotButton = document.createElement('button');
        dotButton.classList.add(this.config.classes.dot);
        dotButton.innerText = i + 1;
        dotButton.dataset.index = i;
        dotNav.appendChild(dotButton);
    }

    slideElement.appendChild(dotNav);
    var dots = dotNav.querySelectorAll('.' + this.config.classes.dot);
    dots = Array.prototype.slice.call(dots);

    this.elements = _extends({}, this.elements, {
        dotNav: dotNav,
        dots: dots
    });
}

function build() {
    if (!this.elements.slider) {
        console.error('no Element to build slider');
        return;
    }

    buildRows.call(this);
    rebuild.call(this);
}

function rebuild() {
    if (this.elements.slides.length < this.config.options.slidesToShow) {
        this.config.options.infinite = false;
        this.config.options.autoplay = false;
        this.config.options.slidesToShow = this.slideCount;
    }

    buildInifiniteRows.call(this);
    buildDots.call(this);
    buildArrows.call(this);
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/slider/build.js
// module id = ./resources/assets/js/src/slider/build.js
// module chunks = 0